import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('settings', ['appCore']),
		userChapters() {
			return this.profile.chapters
		},
		userIsMember() {
			return this.profile?.is_member
		},
		prettyAppBaseMenu() {
			if (!this.appCore) {
				return []
			}
			return this.appCore.appMenuNormalized.baseMenuItems
				.filter((item) => {
					if (!item.title || !item.route) {
						return false
					}
					if (item.chapters && item.chapters.length) {
						let result = false
						item.chapters.forEach((chapter) => {
							if (
								this.userChapters.some(
									(userChapter) => userChapter.chapter_id === chapter
								)
							) {
								result = true
							}
						})
						if (!result) {
							return false
						}
					}
					if (
						item.chapters.length === 0 &&
						item.exclude_chapters &&
						item.exclude_chapters.length
					) {
						const hasExcludedChapter = this.userChapters.some((userChapter) =>
							item.exclude_chapters.includes(userChapter.chapter_id)
						)
						if (hasExcludedChapter) {
							return false
						}
					}
					if (item.role === null || (item.block && item.block === 2)) {
						return true
					} else if (
						(item.role && this.userIsMember) ||
						(!item.role && !this.userIsMember)
					) {
						return true
					}
					return false
				})
				.map((item) => {
					return item
				})
		},
		getLogoUrl() {
			if (!this.prettyAppBaseMenu?.length) return null
			const item = this.prettyAppBaseMenu[0]

			return {
				name: item.route.name,
				query: {
					...(item.route?.query || {}),
					title: item.title || '',
				},
			}
		},
	},
}
